// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	EditButton: 'edit-button',
	ApplyHstCheckbox: 'apply-hst-checkbox',
	ApplyDepositToCommissionCheckbox: 'apply-deposit-to-commission-checkbox',
	DetailsContainer: 'details-container',
	Percentage: 'percentage',
	CommissionPayable: 'commission-payable',
	TypeRadioGroup: 'type-radio-group',
	ExcessDepositReceivedByRadioGroup: 'excess-deposit-received-by-radio-group',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
